import type { ReactNode } from "react";
import { CircleCheckBig, Info, MessageSquareWarning, OctagonAlert } from "lucide-react";
import { Alert, AlertTitle } from "@/components/ui/alert";

export interface AlertProps {
  children?: ReactNode;
  className?: string;
}

export const InfoAlert = ({ children, className }: AlertProps) => (
  <Alert className={className} variant="info">
    <Info className="size-4" />
    <AlertTitle>{children}</AlertTitle>
  </Alert>
);

export const WarningAlert = ({ children, className }: AlertProps) => (
  <Alert className={className} variant="warning">
    <MessageSquareWarning className="size-4" />
    <AlertTitle>{children}</AlertTitle>
  </Alert>
);

export const DangerAlert = ({ children, className }: AlertProps) => (
  <Alert className={className} variant="destructive">
    <OctagonAlert className="size-4" />
    <AlertTitle>{children}</AlertTitle>
  </Alert>
);

export const SuccessAlert = ({ children, className }: AlertProps) => (
  <Alert className={className} variant="success">
    <CircleCheckBig className="size-4" />
    <AlertTitle>{children}</AlertTitle>
  </Alert>
);
